import { apiRoutes } from "../services/apiRoutes";
import menuItems from "./menuItems.json";
import { EntitlementConfig } from "@sphera-cloud/component-ui-reactjs";

const handleHelpLinkClick = async () => {
	try {
		const helpConfigResponse = (await fetch(apiRoutes.helpconfig.get, { method: "GET" }));

		if (helpConfigResponse.ok) {
			const responseData = await helpConfigResponse.json();

			if (responseData.m_Uri) {
				window.open(responseData.m_Uri, '_blank');
			} else {
				console.error("m_Uri value not found in the response.");
			}
		} else {
			const result = await helpConfigResponse.text();
			console.error("Request failed with status: ", result);
		}
	} catch (error) {
		console.error("Error:", error);
	}
};

export const CustomerData = (props) => {
	const listToTree = (list) => {
		var map = {}, node, roots = [], i;

		for (i = 0; i < list.length; i += 1) {
			map[list[i].PhraseSectionTypeId] = i;
			list[i].children = [];
		}

		for (i = 0; i < list.length; i += 1) {
			node = list[i];
			if (node.PhraseSectionType.ParentPhraseSectionTypeId !== null) {
				list[map[node.PhraseSectionType.ParentPhraseSectionTypeId]].children.push(node);
			} else {
				roots.push(node);
			}
		}
		return roots;
	}

    const processColumns = (json, newLocalizations, newLocaleId) => {
        let count = 0;
        let materialColumns = [];
        let documentColumns = [];
        for (var i = 0; i < json.length; i++) {
            // Accumulate into a Map: no computed-key write to a prototype-bearing object, so a
            // DS.ColumnProperties row can never reach the prototype chain. The guard additionally
            // stops a row from shadowing an inherited member once the Map is spread below.
            const columnProps = new Map();
            for (var j = 0; j < json[i].columnPropertyValues.length; j++) {
                const propName = json[i].columnPropertyValues[j].columnProperty.columnProperty1.trim();
                if (propName === "__proto__" || propName === "constructor" || propName === "prototype")
                    continue;
                columnProps.set(propName, json[i].columnPropertyValues[j].columnPropertyValue1.trim());
            }

            // Spread last so a ColumnProperty row still overrides the defaults, as it did before.
			let newCol = { Title: "", width: 200, field: json[i].field, columnId: json[i].columnId, ...Object.fromEntries(columnProps) };

            if (newLocalizations != null && newLocalizations[Object.keys(newLocalizations).find(key => key.toLowerCase() === newCol.Title.toLowerCase())] != null)
                newCol.Title = newLocalizations[Object.keys(newLocalizations).find(key => key.toLowerCase() === newCol.Title.toLowerCase())];

            if (json[i].customerColumns.length > 0) {
                count++;
                newCol.order = json[i].customerColumns[0].columnOrder;
                newCol.width = json[i].customerColumns[0].width;
                newCol.show = json[i].customerColumns[0].selected;
            }
            else
                newCol.show = json[i].customerColumns.selected;

            if (json[i].customerColumns[0].columnLocalizations.length > 0) {
                let used = false;
                for (var j = 0; j < json[i].customerColumns[0].columnLocalizations.length; j++) {
                    if (newLocaleId == json[i].customerColumns[0].columnLocalizations[j].localeId) {
                        newCol.Title = json[i].customerColumns[0].columnLocalizations[j].localization;
                        used = true;
                    }
                }

                if (!used || !newCol.Title) {
                    let enLoc = json[i].customerColumns[0].columnLocalizations.find(x => x.localeId == 1033);
                    if (enLoc != null && enLoc.localization)
                        newCol.Title = enLoc.localization;
                    else if (json[i].customerColumns[0].columnLocalizations[0].localization)
                        newCol.Title = json[i].customerColumns[0].columnLocalizations[0].localization;
                    else
                        newCol.Title = newLocalizations[Object.keys(newLocalizations).find(key => key.toLowerCase() === newCol.Title.toLowerCase())];
                }
            }

            if (!newCol.Title)
                newCol.Title = newCol.field;

            if (json[i].gridId === 1)
                materialColumns.push(newCol);
            else
                documentColumns.push(newCol);
        }
        if (count == 0) {
            for (var i = 0; i < materialColumns.length; i++) {
                materialColumns[i].show = true;
                materialColumns[i].order = i;
            }

            for (var i = 0; i < documentColumns.length; i++) {
                documentColumns[i].show = true;
                documentColumns[i].order = i;
            }
        }

        materialColumns = materialColumns.sort((a, b) => a.order - b.order);
		documentColumns = documentColumns.sort((a, b) => a.order - b.order);
		return { materialColumns, documentColumns, originalColumns: json };
	};

	const updateEntitlements = (localizations, preferencesHandler, activeAccount, customer, products) => {
		let appSwitcher = [];

		if (products.length > 0) {
			let productGroups = Object.groupBy(products, ({ productLine }) => productLine);
			let productLines = Object.entries(productGroups);
			productLines.forEach(x => {
				appSwitcher.push({ productLine: x[0], solutionFamilies: x[1] });
			});
		}

		const entitlementConfig: EntitlementConfig = {
			baseConfig: {
				appSwitcherHeader: localizations.Subscribed ?? "Subscribed",
				activeSolutionFamily: "Corporate Sustainability",
				rootComponent: "#sch",
				baseUrl: "/",
				mobileMenu: false,
				footer: {
					url: "https://sphera.com",
					label: localizations.ExploreAdd ?? "ExploreAdd",
				},
			},
			user: {
				name: activeAccount && activeAccount.name ? activeAccount.name : 'Unknown',
				avatar: "",
				company: customer != null && customer.CustomerName != null ? customer.CustomerName : "",
				email: activeAccount && activeAccount.idTokenClaims.email ? activeAccount.idTokenClaims.email : 'Unknown',
				menuItems: [
					{
						"label": localizations.Preferences ?? "Preferences",
						onClick: preferencesHandler,
						"id": "preferences"
					},
					{
						"label": localizations.Signout ?? "SignOut",
						onClick: () => props.navigate("/logout"),
						"id": "logout-url"
					}
				],
			},
			help: {
				links: [
					{
						label: localizations.GetHelp ?? "GetHelp",
						onClick: handleHelpLinkClick,
					},
					{
						label: localizations.ThirdPartyNotice ?? "ThirdPartyNotice",
						onClick: () => props.navigate("/thirdpartynotice")
					}
				],
			},
			appSwitcher: appSwitcher
		};
		return entitlementConfig;
	}

	const getCustomerData = async (localeId) => {
		let products = [];
		let currentTenent = {};
		let localizations = {};
		let customer = {};
		let INIT_MENUS = [];
		let PortalBaseDomain = "";
		let landingPageUrl = "";
        let json = await props.execute("GET", `${apiRoutes.users.requiredData}/${localeId}`);
		if (json != null) {
			if (json.status === 401 || json.CurrentTenant === null) {
				var emptyProducts = [];
				emptyProducts.push({
					group: "",
					url: "",
					iconColor: "",
					shortcut: "",
					modules: []
				});
				products = [emptyProducts];
				props.navigate("/NoPermissions");
			}
			else {
				currentTenent = json.CurrentTenant;

				let newLocalizations = {};
				for (let i = 0; i < json.localizations.length; i++) {
					newLocalizations[json.localizations[i].Key] = json.localizations[i].TextValue;
				}

				localizations = newLocalizations;
				json.customer.PhraseSections = listToTree(json.PhraseSections.sort((a, b) => a.SortOrder - b.SortOrder));
				json.customer.PhraseSections.forEach(x => {
					x.title = x.PhraseSectionType.Name;
				});
				customer = json.customer;

				let MENUS = JSON.parse(JSON.stringify(menuItems.MENUS));
				let adminUrl = "/config";
				if (!json.CurrentTenant.IsEditConfigUser) {
					adminUrl = "";
					MENUS = MENUS.filter(x => !(x.url == "/config" && x.parentId != null));
				}
				if (adminUrl == "") adminUrl = "/DefaultTextList";
				if (!json.CurrentTenant.IsEditDefaultTextUser) {
					if (adminUrl == "/DefaultTextList") adminUrl = "";
					MENUS = MENUS.filter(x => x.url !== "/DefaultTextList");
				}
				if (adminUrl == "") adminUrl = "/filters";
				if (!json.CurrentTenant.IsEditFiltersUser) {
					if (adminUrl == "/filters") adminUrl = "";
					MENUS = MENUS.filter(x => x.url !== "/filters");
				}
				if (adminUrl == "") adminUrl = "/manageCustomers";
				if (!json.CurrentTenant.IsManageCustomersAdmin) {
					if (adminUrl == "/manageCustomers") adminUrl = "";
					MENUS = MENUS.filter(x => x.url !== "/manageCustomers");
				}
				if (!json.CurrentTenant.IsReviewHistoryUser) {
					MENUS = MENUS.filter(x => x.url !== "/reviewHistory");
				}
				if (!json.CurrentTenant.IsEditCustomerPortalUser) {
					MENUS = MENUS.filter(x => x.url !== "/customerPortal");
				}
				if (!json.CurrentTenant.IsEditConfigUser &&
					!json.CurrentTenant.IsManageCustomersAdmin &&
					!json.CurrentTenant.IsEditFiltersUser &&
					!json.CurrentTenant.IsEditDefaultTextUser) {
					MENUS = MENUS.filter(x => !(x.url == "/config" && x.parentId == null));
				}
				MENUS.forEach(item => {
					item.label = newLocalizations[item.label] || item.label;
					if (adminUrl != "/config" && item.url == "/config" && item.parentId == null) item.url = adminUrl;
				});

				INIT_MENUS = MENUS;
				if (json.portalBaseDomain) {
					PortalBaseDomain = json.portalBaseDomain;
				}
				products = [];
				let containsDs = false;
				try {
					let entitlements = json.entitlement;
					for (let i = 0; i < entitlements.products.length; i++) {
						if (json.DsProductId === entitlements.products[i].productId)
							containsDs = true;

						products.push({
							group: entitlements.products[i].solutionName,
							url: entitlements.products[i].productUrl,
							iconColor: entitlements.products[i].iconColor,
							shortcut: entitlements.products[i].shortcut,
							modules: [],
							productLine: entitlements.products[i].productLine
						});
					}
				}
				catch (ex) {
					console.error(ex + " entitlement: " + json.entitlement);
				}

				if (json.CurrentTenant.CustomerStatus !== 1 || !containsDs) {
					landingPageUrl = json.landingPageUrl;
					json.CurrentTenant.RequiresNavMenu = false;
					currentTenent = json.CurrentTenant;
					props.navigate(json.CurrentTenant.IsSpheraUser ? "/SpheraNoPermissions" : "/NoPermissions");
				}
			}

			let columns = await getColumns(localizations, localeId);
			customer.columns = columns;
		}

		return { products, currentTenent, localizations, customer, INIT_MENUS, PortalBaseDomain, landingPageUrl };
    };

    const getLocalizations = async (localeId, originalColumns) => {
        let response = await props.execute("GET", `${apiRoutes.documents.localizations}?interfaceLocaleId=${localeId}`);
        let newLocalizations = {};
        for (let i = 0; i < response.length; i++) {
            newLocalizations[response[i].key] = response[i].textValue;
        }

        let MENUS = JSON.parse(JSON.stringify(menuItems.MENUS));
        MENUS.forEach(item => {
            item.label = newLocalizations[item.label] || item.label;
        });

        let columns = processColumns(originalColumns, newLocalizations, localeId);
        return { MENUS, newLocalizations, columns };
    };

	const getColumns = async (localizations, localeId) => {
        let response = await props.execute("GET", `${apiRoutes.column.GetColumns}`);

        return processColumns(response, localizations, localeId);
    }

    return {
        getLocalizations,
        getColumns,
		getCustomerData,
		updateEntitlements,
		processColumns
    };
}